import { UserProfilesType } from './types';
import { api } from '../apiService';

const getProfiles = (publishName = ''): Promise<UserProfilesType> =>
  api.get<UserProfilesType>(`/user-profiles?publishName=${publishName}`).then(res => res.data);

export const userProfileService = {
  getProfiles,
};
